const settingService = {
  queryJcombobox: '/logisticsZipCodeLimitTemplate/jcombobox',
  // 新增店铺-自动添加店铺超级管理员店铺权限
  addStore: '/storeSuperAdministrator/addStore',
  // 偏远地区费用模板 - 列表查询接口  post http://192.168.91.7:882/project/343/interface/api/15389
  queryRemoteAreaCostTemplateList: '/templateInfo/queryRemoteAreaCostTemplateList',
  // 偏远地区费用模板 - 详情查询接口 /{id} post http://192.168.91.7:882/project/343/interface/api/15393
  queryRemoteAreaCostTemplateDetail: '/templateInfo/queryRemoteAreaCostTemplateDetail',
  // 偏远地区费用模板 - 新增接口  post http://192.168.91.7:882/project/343/interface/api/15401
  insertRemoteAreaCostTemplate: '/templateInfo/insertRemoteAreaCostTemplate',
  // 偏远地区费用模板 - 修改接口 post http://192.168.91.7:882/project/343/interface/api/15397
  updateRemoteAreaCostTemplate: '/templateInfo/updateRemoteAreaCostTemplate',
  // 偏远地区费用模板 - 获取所有物流商及物流方式接口 get
  queryEnableCarriersAndShippingMethod: '/carrier/queryEnableCarriersAndShippingMethod',
  // 偏远地区费用模板 - 修改偏远的地区费用模板状态 post /{id}?status=1  http://192.168.91.7:882/project/343/interface/api/15405
  updateRemoteAreaCostTemplateStatus: '/templateInfo/updateRemoteAreaCostTemplateStatus',
  // 查询temu店铺主体  http://192.168.91.7:882/project/343/interface/api/15587
  developerList: '/saleAccount/temu/developerList',
  // wb 店铺添加新绑定 http://192.168.91.7:882/project/343/interface/api/16006
  createWb: '/wbAccount/create',
  // wb 店铺编辑/授权 http://192.168.91.7:882/project/343/interface/api/16010
  editWb: '/wbAccount/edit',
  // 查询物流邮编限制模板列表 http://192.168.91.7:882/project/343/interface/api/16193
  zipCodeQueryPage: '/logisticsZipCodeLimitTemplate/queryPage',
  // 新增物流邮编限制模板 http://192.168.91.7:882/project/343/interface/api/16192
  zipCodeAdd: '/logisticsZipCodeLimitTemplate/add',
  // 编辑物流邮编限制模板 http://192.168.91.7:882/project/343/interface/api/16195
  zipCodeEdit: '/logisticsZipCodeLimitTemplate/edit',
  // 删除物流邮编限制模板 http://192.168.91.7:882/project/343/interface/api/16204
  zipCodeDel: '/logisticsZipCodeLimitTemplate/del',
  // 查询物流邮编限制模板绑定的邮寄方式列表 http://192.168.91.7:882/project/343/interface/api/16194
  queryRelShippingMethod: '/logisticsZipCodeLimitTemplate/queryRelShippingMethod',
  // 查询物流邮编限制模板指定邮编列表 http://192.168.91.7:882/project/343/interface/api/16198
  queryPostcodePage: '/logisticsZipCodeLimitTemplateAppoint/queryPage',
  // 删除物流邮编限制模板指定邮编列表 http://192.168.91.7:882/project/343/interface/api/16199
  delPostcode: '/logisticsZipCodeLimitTemplateAppoint/del',
  // 查询物流邮编限制模板邮编开头列表 http://192.168.91.7:882/project/343/interface/api/16202
  queryOutsetPage: '/logisticsZipCodeLimitTemplateStart/queryPage',
  // 删除物流邮编限制模板邮编开头列表 http://192.168.91.7:882/project/343/interface/api/16203
  delOutset: '/logisticsZipCodeLimitTemplateStart/del',
  // 查询物流邮编限制模板邮编区间列表 http://192.168.91.7:882/project/343/interface/api/16200
  queryRangePage: '/logisticsZipCodeLimitTemplateInterval/queryPage',
  // 删除物流邮编限制模板邮编区间列表 http://192.168.91.7:882/project/343/interface/api/16201
  delRange: '/logisticsZipCodeLimitTemplateInterval/del',
  // 导入物流邮编限制模板邮编 http://192.168.91.7:882/project/343/interface/api/16196
  importExcel: '/logisticsZipCodeLimitTemplate/importExcel',
  // 导出物流邮编限制模板邮编 http://192.168.91.7:882/project/343/interface/api/16197
  exportExcel: '/logisticsZipCodeLimitTemplate/exportExcel',
  // 校验指定邮编 http://192.168.91.7:882/project/343/interface/api/16544
  checkZipCode: '/logisticsZipCodeLimitTemplate/checkZipCode',
  // 新增邮编限制 http://192.168.91.7:882/project/343/interface/api/16553
  addZipCode: '/logisticsZipCodeLimitTemplate/addZipCode',
}
// 客服管理-自动回复
const replyTemplate = {
  // 新增模板 http://192.168.91.7:882/project/363/interface/api/15982
  add: '/replyTemplate/add',
  // 编辑 http://192.168.91.7:882/project/363/interface/api/15984
  edit: '/replyTemplate/edit',
  // 分页查询 http://192.168.91.7:882/project/363/interface/api/15985
  queryAll: '/replyTemplate/queryAll',
  // 上传图片 http://192.168.91.7:882/project/363/interface/api/15986
  uploadPicture: '/replyTemplate/uploadPicture',
  // 启用模板 http://192.168.91.7:882/project/363/interface/api/15987
  enable: '/replyTemplate/enable',
  // 停用模板 http://192.168.91.7:882/project/363/interface/api/15988
  stop: '/replyTemplate/stop',
  // 详情 http://192.168.91.7:882/project/363/interface/api/15989
  detail: '/replyTemplate/detail'
}

let settingApi = {};
const handApi = (base, baseKey, apiData) => {
  if (!baseKey) {
    for (let key in apiData) {
      settingApi[key] = `${base}${apiData[key]}`;
    }
  } else {
    settingApi[baseKey] = {};
    for (let key in apiData) {
      settingApi[baseKey][key] = `${base}${apiData[key]}`;
    }
  }
}

handApi('/setting-service', 'settingService', settingService);
handApi('/cs-service', 'replyTemplate', replyTemplate);

export default settingApi;
